import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LangContext';
import { BRAND, SERVICE_AREAS } from '../../data/siteData';
import { Phone, Mail, MapPin } from 'lucide-react';
import WhatsAppIcon from './WhatsAppIcon';

const WHATSAPP_NUMBER = BRAND.phone;
const WHATSAPP_LINK = "https://wa.me/1" + WHATSAPP_NUMBER.replace(/\D/g, "");

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-[#0B0D0F] border-t border-white/8 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <h3 className="text-white font-bold text-lg font-outfit tracking-wider mb-2">MIAMI MULTI-TRADE</h3>
            <p className="text-[#D4AF37] text-[10px] tracking-[0.2em] uppercase mb-4">{t.hero.badge}</p>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">{t.hero.tagline}</p>
            <p className="text-slate-500 text-xs">{t.footer.operated} Dviso</p>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-outfit">{t.footer.services}</h4>
            <div className="space-y-2">
              <Link to="/general-contractor-miami" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-general-contractor">General Contractor Miami</Link>
              <Link to="/remodeling-miami" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-remodeling">Home Remodeling Miami</Link>
              <Link to="/kitchen-remodeling-miami" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-kitchen">Kitchen Remodeling Miami</Link>
              <Link to="/bathroom-remodeling-miami" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-bathroom">Bathroom Remodeling Miami</Link>
              <Link to="/outdoor-living-miami" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-outdoor">Outdoor Living Miami</Link>
              <Link to="/project-management-miami" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-project-management">Construction Project Management</Link>
              <Link to="/emergency-services" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-emergency">Emergency Plumbing & Electrical</Link>
              <Link to="/projects" className="block text-slate-400 text-sm hover:text-[#D4AF37] transition-colors" data-testid="footer-link-projects">Completed Projects</Link>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-outfit">{t.footer.areas}</h4>
            <div className="space-y-2">{SERVICE_AREAS.slice(0, 8).map(a => <p key={a} className="text-slate-400 text-sm">{a}</p>)}</div>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-outfit">{t.footer.contactLabel}</h4>
            <div className="space-y-3">
              <a href={`tel:${BRAND.phone}`} className="flex items-center gap-2 text-slate-400 text-sm hover:text-white transition-colors"><Phone className="w-4 h-4 text-[#D4AF37]" />{BRAND.phone}</a>
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 text-slate-400 text-sm hover:text-white transition-colors"><Mail className="w-4 h-4 text-[#D4AF37]" />{BRAND.email}</a>
              <div className="flex items-start gap-2 text-slate-400 text-sm"><MapPin className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />{BRAND.address}</div>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-btn"
                className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5B] text-black font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors mt-1">
                <WhatsAppIcon className="w-4 h-4" />{t.footer.whatsapp}
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2 border-t border-white/8 pt-8 pb-2">
          <img src="/dviso-logo.png" alt="Dviso Construction" data-testid="footer-dviso-logo" className="h-20 sm:h-24 w-auto object-contain" />
          <p className="text-slate-500 text-xs">{t.footer.operated} Dviso Construction</p>
        </div>
        <div className="border-t border-white/8 pt-6 pb-4">
          <p data-testid="footer-license-notice" className="text-slate-300 text-xs sm:text-sm text-center leading-relaxed max-w-4xl mx-auto bg-white/5 border border-white/10 rounded-lg px-4 py-3">{t.footer.license}</p>
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-6">
            <p className="text-slate-500 text-xs">&copy; {new Date().getFullYear()} Miami Multi-Trade. {t.footer.rights}</p>
            <p className="text-slate-600 text-xs italic">{t.footer.disclaimer}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
